import {useMemo, useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {IState} from '../../../shared/store/reducers';
import {Report} from '../../../shared/models';
import {toggleSelectReport} from '../../../shared/store/actions/reportActions';

export function useSelectReport(reportId: string) {
  const dispatch = useDispatch();
  const reports = useSelector((state: IState) => state.report.reports);
  const report = reports?.find((report: Report) => report.uid === reportId) || null;
  const selected = useMemo(() => report?.selected || false, [report?.selected]);

  const onChange = useCallback((selected: boolean) =>
    dispatch(toggleSelectReport(reportId, selected)),
    [reportId]
  );

  return {
    selected,
    onChange,
  }
}
